import { UNIFIED_DROPDOWN_MAX_HEIGHT_REM } from '@themes/overrides/constants';

export default function Autocomplete() {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        tag: {
          margin: '0 0.188rem 0.125rem 0',
        },
        listbox: {
          overscrollBehavior: 'auto',
          maxHeight: UNIFIED_DROPDOWN_MAX_HEIGHT_REM,
        },
        root: {
          '& span.MuiAutocomplete-tag.MuiAutocomplete-tagSizeSmall': {
            maxWidth: '1rem',
          },
          '& .MuiChip-root': {
            maxHeight: '1.25rem',
            maxWidth: 'calc(100% - 4rem)',
          },
          '& .MuiOutlinedInput-root': {
            '& .MuiAutocomplete-endAdornment': {
              right: 0,
              '& button': {
                margin: 0,
                width: '2.125rem',
                height: '2.125rem',
              },
            },
          },
        },
      },
    },
  };
}
